// extracted by mini-css-extract-plugin
export var footer = "_mc-5";
export var fulfillmentInput = "_mc-0";
export var shipDateInput = "_mc-1";
export var shipmentModal = "_mc-2";
export var shipmentModalContent = "_mc-3";
export var tableContainer = "_mc-4";